/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters to format into criteria descriptors
 */
export type RubricDimensionOutputParams = { [key: string]: unknown };
